<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-breadcrumbs [crumbs]="breadCrumbs"></app-st-breadcrumbs>
      <app-st-header-title [inputVal]="'Reset Password'"></app-st-header-title>
      <br>
      <div class="container st-form">
        <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
          <app-st-span><b>Please validate the following: </b></app-st-span>
          <!--<p *ngFor="let errorMsg of messages"><b>{{errorMsg.field}}:</b> {{errorMsg.detail}}</p>-->
          <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div>
          <app-st-input-sensitive-text [idVal]="'new-password-text-id'" [label]="'New Password'"></app-st-input-sensitive-text>
          <app-st-input-sensitive-text [idVal]="'repeat-password-text-id'" [label]="'Repeat New Password'"></app-st-input-sensitive-text>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'save-button-id'" [label]="'Save'" [primary]="true"
                         (click)="this.onSubmit()"></app-st-button>
          <app-st-button [idVal]="'cancel-button-id'" [label]="'Cancel'" [primary]="false"
                         (click)="this.onCancel()"></app-st-button>
        </div>
      </div>

    </div>
  </div>
</div>
